import styled from 'styled-components';

export const TableContainer = styled.div`
  padding: 0 1rem 0 1rem;
`;

export const ContainerInfo = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin: 1rem;
  display: flex;
  justify-content: flex-end;
`;

export const SummaryContainerCell = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;

  & > div {
    padding-right: 4.5rem;
  }
`;
